import { APIResponseType } from 'app/apiService/types';
import apiService from 'app/apiService';
import { RevenueOperationsScorecard } from '../types';
import mockData from '../mockData.json';

class ScorecardApiService {
  static ENDPOINT = 'api/v2/analytics/scorecard';

  static async getRevenueOperationsScorecard(dealerId: string): Promise<APIResponseType<RevenueOperationsScorecard>> {
    if (!dealerId) {
      throw new Error('Dealer ID is required to fetch scorecard');
    }

    try {
      // For now, return mock data instead of actual API call
      // TODO: Replace with actual API call when backend is ready
      const response = await apiService.get<APIResponseType<RevenueOperationsScorecard>>(
        `${this.ENDPOINT}/${dealerId}`
      );
      console.log('response', response);
      return response;

      // Mock response structure matching APIResponseType
      // return {
      //   body: mockData as RevenueOperationsScorecard,
      //   message: 'Scorecard data retrieved successfully',
      //   statusCode: 200,
      // };
    } catch (error) {
      console.error('Error fetching revenue operations scorecard:', error);
      throw error;
    }
  }
}

export default ScorecardApiService;

